export default "__VITE_ASSET__Bjw6pMk1__"